<template>
<Panel  :toggleable="true" :collapsed="true" >

 <template #header>
   <p class="my-2"><span class="handle mr-2"><i class="pi pi-align-justify"></i> </span><b class="text-primary">{{option.name}}</b></p>
</template>
<template #icons>
    <button class="p-panel-header-icon p-link mr-2" @click="toggle">
        <span class="pi pi-ellipsis-h"></span>
    </button>
    <Menu id="config_menu" ref="menu" :model="menuitems" :popup="true" />
</template>

<ClickEditInputText  title="Kategori İsmi" :value="option.name" :valkey="option.id" @dataChanged="optionChanged"></ClickEditInputText>

<div  v-for="language in languages" :key="language.id">
<ClickEditInputText  v-for="translation in option.translations" :key="translation.id" :title="language.name+ ' İsmi'" :value="translation.translation" :valkey="translation.id" @dataChanged="optiontranslationChanged" v-show="translation.language_id == language.id"></ClickEditInputText> 
</div>

</Panel>
</template>

<script>
export default {

  name: 'CascadeCategoryBrandAttributeOptions',
  props:["option","languages"],
  data () {
    return {
    	menuitems: [
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                command: () => {
                    this.deleteItem("custom_attribute_option",this.option.id)
                }
            },
        ],

    }
  },
  methods:{
  	toggle(event) {
        this.$refs.menu.toggle(event);
    },
  	optionChanged(data)
  	{		
		let formdata = new FormData()
		formdata.append("name",data.value)
		this.generalSubmission(formdata,"custom_attribute/update_option/"+data.key,this.renewData)
  	},
  	optiontranslationChanged(data)
  	{
  			console.log(data.value)
    		console.log(data.key)
    		let formdata = new FormData()
    		formdata.append("data",data.value)
    		this.generalSubmission(formdata,"custom_attribute/update_option_translation/"+data.key,this.renewData)
  	},
  	renewData(response)
  	{
  		this.$emit("dataRenewed")
  	},

  }
}
</script>

<style lang="css" scoped>
</style>